import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModuleService } from '../services/module.service';

import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-modal-read-ppr',
  templateUrl: './modal-read-ppr.component.html',
  styleUrls: ['./modal-read-ppr.component.css']
})
export class ModalReadPprComponent implements OnInit {
  @ViewChild('content') content: ElementRef;
  @Input() pprDataset;

  localFacilities = localStorage.getItem('localFacilities');
  localID = localStorage.getItem('localID');
  localModules = localStorage.getItem('localModules');

  facility = JSON.parse(this.localFacilities);
  id = JSON.parse(this.localID);
  modules = JSON.parse(this.localModules);

  currentFacility = this.facility[this.id];

  titleModal: string;
  chartType: string;
  pprChartMap: Map<string, number> = new Map();
  chartLabel: Array<string> = [];
  chartData: Array<number> = [];
  chartDataset: Array<any> = [];
  chartOptions = { responsive: true };
  chartLegend = true;
  lineChartType = 'line';
  barChartType = 'bar';
  monthNames = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

  chartColors = [
    {
      backgroundColor: '#dc598b38',
      borderColor: '#DC598B',
      pointBackgroundColor: '#DC598B',
      pointBorderColor: '#DC598B',
      pointHoverBackgroundColor: '#DC598B',
      pointHoverBorderColor: '#DC598B'
    },
  ];

  constructor(
    private router: Router,
    private translate: TranslateService,
    private moduleService: ModuleService,
    private modal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.translate.use(localStorage.getItem('localLanguage'));
    this.setPprMAP();
    this.setDatasetForCharts();
    console.log(this.pprDataset);
  }

  close() {
    this.modal.close()
  }

  setPprMAP() {
    for (let dataset of this.pprDataset.dataset) {
      this.titleModal = dataset.title;
      this.chartType = dataset.type;
      for (let value of dataset.value)
        this.pprChartMap.set(value.label, value.value);
    }

  }

  setDatasetForCharts() {
    this.pprChartMap.forEach((value, key) => {
      const dateSplitted = key.split('/');
      const dateString = dateSplitted[0] + '/' + '01' + '/' + dateSplitted[1]
      const labelDate = new Date(dateString);
      this.chartLabel.push(this.monthNames[labelDate.getMonth()] + ' ' + labelDate.getUTCFullYear());
      this.chartData.push(value);
    });

    let titleModalSplitted = this.titleModal.split(" ", 2);
    this.chartDataset.push({ data: this.chartData, label: titleModalSplitted[0] + ' ' + titleModalSplitted[1] });
  }


  downloadChartPPR() {
    let facilityName = '';
    let facilityAddress = '';
    let facilityCity = '';
    let dateString = this.pprDataset.date.split(" ");
    let pprRequestDate = '';

    this.translate.get('STRUCTURE.TITLE').subscribe((res: string) => {
      facilityName = res + ':' + ' ' + this.currentFacility.myFacilities.Nome;
    });

    this.translate.get('ADDRESS.TITLE').subscribe((res: string) => {
      facilityAddress = res + ':' + ' ' + this.currentFacility.myFacilities.Address;
    });

    this.translate.get('CITY.TITLE').subscribe((res: string) => {
      facilityCity = res + ':' + ' ' + this.currentFacility.myFacilities.City;
    });

    this.translate.get('PPR_PDF_DATE.TITLE').subscribe((res: string) => {
      pprRequestDate = res + ' ' + dateString[0];
    });

    html2canvas(this.content.nativeElement).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png');
      const doc = new jsPDF('p', 'mm', 'a4');
      let width = 180;
      let height = 80;

      doc.setFont('Helvetica');
      doc.setFontStyle('italic');
      doc.setTextColor(74, 74, 74);

      let pdfRequestPPRDate = doc.setFontSize(15);
      pdfRequestPPRDate.text(pprRequestDate, 100, 10, 'center');

      let pdfFacilityName = doc.setFontSize(10);
      pdfFacilityName.text(facilityName, 10, 30, 'left')

      let pdfFacilityAddress = doc.setFontSize(10);
      pdfFacilityAddress.text(facilityAddress, 10, 35, 'left')

      let pdfFacilityCity = doc.setFontSize(10);
      pdfFacilityCity.text(facilityCity, 10, 40, 'left')


      let titlePDF = doc.setFontSize(10);
      titlePDF.text(this.titleModal, 100, 70, 'center');


      doc.text("Powered by Amodto", 100, 290, 'center')


      doc.addImage(contentDataURL, 'JPEG', 10, 80, width, height);
      doc.save(this.titleModal + '.pdf');
    });
  }

}
